import React from 'react';
import PropTypes from 'prop-types';
import Box from 'common/src/components/Box';
import Text from 'common/src/components/Text';
import Heading from 'common/src/components/Heading';
import Button from 'common/src/components/Button';
import Image from 'common/src/components/Image';
import Container from 'common/src/components/UI/Container';

import {
  PartnerSectionWrapper,
  PartnerFormWrapper,
  PhoneNumberWrapper
} from './partner.style';

import Partner from 'common/src/assets/image/saas/partner.png';

import Input from 'common/src/components/Input';

const PartnerSection = ({
  row,
  col,
  title,
  description,
  button,
  textArea,
  imageArea
}) => {
  return (
    <PartnerSectionWrapper id="contact_section">
      <Container>
        <Box {...row}>
          <Box {...col} {...imageArea}>
            <Image
              border={true}
              src={Partner}
              alt="Zdjęcie zamawiającej usługę"
            />
          </Box>
          <Box {...col} {...textArea}>
            <Heading {...title} content="Skontaktuj się z nami" />
            <Text
              {...description}
              content="Zostaw do nas kontakt lub zadzwoń, dowiesz się więcej o warunkach współpracy. Numer telefonu:"
            />
            <PhoneNumberWrapper>
              <p>+48 501 361 666</p>
            </PhoneNumberWrapper>
            <Box>
              <PartnerFormWrapper
                name="contact"
                method="POST"
                data-netlify="true"
                action="/dziekujemy"
                data-netlify-honeypot="bot-field"
              >
                <input type="hidden" name="bot-field" />
                <input type="hidden" name="form-name" value="contact" />
                {/* <PartnerFormRow>
                  <Input
                    isMaterial={true}
                    type="text"
                    label="Imię"
                    required
                  ></Input>
                  <Input
                    isMaterial={true}
                    type="text"
                    label="Nazwisko"
                    required
                  ></Input>
                </PartnerFormRow> */}
                {/* <PartnerFormRow> */}
                {/* <Input isMaterial={true} type="phone" label="Telefon"></Input> */}
                <Input
                  isMaterial={true}
                  type="email"
                  label="Podaj swój email"
                  required
                ></Input>
                {/* </PartnerFormRow> */}
                <Button {...button} type="submit" title="Wyślij" />
              </PartnerFormWrapper>
            </Box>
          </Box>
        </Box>
      </Container>
    </PartnerSectionWrapper>
  );
};

PartnerSection.propTypes = {
  row: PropTypes.object,
  col: PropTypes.object,
  title: PropTypes.object,
  description: PropTypes.object,
  button: PropTypes.object,
  textArea: PropTypes.object,
  imageArea: PropTypes.object
};

PartnerSection.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
    alignItems: 'center'
  },
  imageAreaRow: {
    flexDirection: 'row-reverse'
  },
  col: {
    pr: '15px',
    pl: '15px'
  },
  textArea: {
    width: ['100%', '100%', '55%', '50%', '42%']
  },
  imageArea: {
    width: ['100%', '100%', '45%', '50%', '58%'],
    mb: ['40px', '40px', '0', '0', '0']
  },
  title: {
    fontSize: ['26px', '30px', '30px', '48px', '48px'],
    fontWeight: '400',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: '15px',
    lineHeight: '1.5'
  },
  description: {
    fontSize: '16px',
    color: '#343d48cc',
    lineHeight: '1.75',
    mb: '33px'
  },
  button: {
    type: 'button',
    fontSize: '14px',
    fontWeight: '600',
    color: '#fff',
    borderRadius: '4px',
    pl: '22px',
    pr: '22px',
    colors: 'primaryWithBg'
  }
};

export default PartnerSection;
